import * as swcHelpers from '@swc/helpers';
import isPlainObject from 'lodash/isPlainObject';
import { LocaleUtils, getLocalizedValue } from '@grandvisionhq/utils';

const getLocalizedAttributes = (attributes, locale)=>{
    if (!attributes || !LocaleUtils.isValidLocale(locale)) {
        console.error(`getLocalizedAttributes missing attributes or invalid locale: ${locale}`);
        return [];
    }
    return attributes.map((attr)=>{
        if (Array.isArray(attr.value)) {
            return swcHelpers.objectSpread({}, attr, {
                value: attr.value.map((val)=>getLocalizedValue(val, locale)
                )
            });
        }
        if (isPlainObject(attr.value)) {
            return swcHelpers.objectSpread({}, attr, {
                value: getLocalizedValue(attr.value, locale)
            });
        }
        return attr;
    });
};

export { getLocalizedAttributes };
//# sourceMappingURL=get-localized-attributes.js.map
